import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { enqueueSnackbar } from 'notistack';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FaSchool, FaCalendarAlt, FaUserFriends, FaUserSecret } from 'react-icons/fa';
import SurveyProgressBar from './SurveyProgressBar';
import SurveyStatusPill from './SurveyStatusPill';
import { deleteSurvey } from '../../../services/SurveyService';

const SurveyCard = ({ survey, onDeleted }) => {
  const navigate = useNavigate();
  const permissions = JSON.parse(localStorage.getItem('permissions')) || [];
  const {
    id, title, status, programs = [], is_student_specific, assigned_students,
    is_anonymous, start_date, end_date, start_time, end_time, targeted_students, completed_responses,
  } = survey;

  const total = targeted_students ?? 0;
  const responded = completed_responses ?? 0;

  const handleDelete = async () => {
    if (!window.confirm('Are you sure you wish to delete this item?')) return;
    try {
      const response = await deleteSurvey(id);
      if (response.status === 200) {
        enqueueSnackbar('Survey deleted successfully', { variant: 'success' });
        if (onDeleted) onDeleted();
      }
    } catch (error) {
      console.error('API Error:', error.response);
      enqueueSnackbar('Could not delete the survey', { variant: 'error' });
    }
  };

  return (
    <div className="survey-card">
      <div className="survey-card-top">
        <Link to={`/surveys/${id}`} className="survey-card-title">{title}</Link>
        <div className="survey-card-top-right">
          <SurveyProgressBar value={responded} max={total} />
          {(permissions.includes('survey.update') || permissions.includes('survey.delete')) && (
            <span>
              {permissions.includes('survey.update') &&
                <FontAwesomeIcon
                  icon={faEdit}
                  style={{ color: 'var(--color-primary-text)', marginRight: '10px', cursor: 'pointer' }}
                  onClick={() => navigate(`/import/survey/${id}`)}
                />
              }
              &nbsp;
              {permissions.includes('survey.delete') &&
                <span className="cursor-pointer" onClick={handleDelete}>
                  <i className="fa fa-trash text-danger"></i>
                </span>
              }
            </span>
          )}
        </div>
      </div>
      <div className="survey-card-meta">
        <div className="survey-card-meta-left">
          <SurveyStatusPill status={Number(status) === 1 ? 'active' : 'ended'} />
          {is_student_specific && (
            <span className="survey-audience-chip">
              <FaUserFriends /> {assigned_students} students
            </span>
          )}
          {is_anonymous && (
            <span className="survey-audience-chip">
              <FaUserSecret /> Anonymous
            </span>
          )}
          <span className="survey-meta-chip">
            <FaSchool />
          </span>
          {programs.map((p, index) => (
            <span key={`${p.program_id}-${index}`} className="survey-meta-chip survey-chip-solid">
              {p.program?.name}
            </span>
          ))}
          <span className="survey-meta-chip">
            <FaCalendarAlt /> {start_date} {start_time} → {end_date} {end_time}
          </span>
        </div>
        <div className="survey-card-completion">
          {total > 0 ? Math.round((responded / total) * 100) : 0}% completion
        </div>
      </div>
    </div>
  );
};

export default SurveyCard;
